<template>
  <div class="release-container">
    <div class="head-title">
      <p>发布数据需求</p>
    </div>
    <div class="content-box">
      <el-form
        inline-message
        ref="formRef"
        :label-position="labelPosition"
        label-width="83px"
        :model="formLabelAlign"
        :rules="rules"
      >
        <el-form-item label="需求标题" prop="name">
          <el-input
            v-model="formLabelAlign.name"
            class="eleInput"
            type="text"
            placeholder="请输入数据需求名称"
            maxlength="40"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="行业分类" prop="industry">
          <el-select
            v-model="formLabelAlign.industry"
            style="width: 570px"
            multiple
            placeholder="请选择数据类型"
          >
            <el-option
              class="select"
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="附件上传" prop="data">
          <div class="UploadBox">
            <el-upload
              action="#"
              class="upload-demo"
              :http-request="UploadFile"
              ref="UploadRef"
              v-model="formLabelAlign.data"
              :on-remove="handleRemove"
              :show-file-list="false"
            >
              <el-button size="small" type="primary" class="uploadbtn"
                >选择文件</el-button
              >
              <div slot="tip" class="el-upload__tip">单附件大小20MB以内</div>
            </el-upload>
          </div>
          <div
            class="attachment-box"
            v-if="formLabelAlign.data.length > 0 && formLabelAlign.data[0]"
          >
            <img
              class="file-icon"
              src="https://img.icons8.com/ios-filled/50/000000/ms-word.png"
              alt="Word文件"
            />
            <div class="file-info">
              <div class="file-name">
                {{ SplieName(formLabelAlign.data[0]) }}
              </div>
              <div class="file-size">大小：7.5MB</div>
            </div>
            <a class="download-link" @click="DelFile">删除附件</a>
          </div>
        </el-form-item>
        <el-form-item label="需求描述" class="Text" prop="description">
          <el-input
            type="textarea"
            v-model="formLabelAlign.description"
            style="width: 570px; height: 120px"
            resize="none"
            placeholder="请具体描述您的数据资源需求,限3000字以内，如超出请传附件"
          ></el-input>
        </el-form-item>
        <div class="originalBox" v-if="$store.state.type === 3">
          <div class="OneTitle">二、原始需求</div>
          <div class="originalBox-select" v-if="tableData.length===0">
            <el-input
              v-model="formLabelAlign.original"
              placeholder="请输入原始需求id"
            ></el-input>
            <el-button type="primary" @click="getOriginal">确认关联</el-button>
          </div>
          <div class="Datasets Datasets1" v-if="tableData.length>0">
            <el-table
              :data="tableData"
              style="width: 100%"
              :stripe="false"
              :row-style="{
                border: '1px solid #eee',
                borderRadius: '4px',
                marginTop: '5px',
              }"
            >
              <el-table-column label="主题" width="248">
                <template slot-scope="scope">
                  <span class="DataSpan">{{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布者">
                <template slot-scope="scope">
                  <span class="DataSpan">{{ getUserInfo(scope.row.user_id) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small" class="delSpan"
                     @click="delOriginal(scope.row.id)" >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <el-form-item>
          <div class="btnlist">
            <button class="sucess" @click.prevent="release">发布需求</button>
            <button class="save" @click.prevent="draft">存草稿</button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import iconEye from "@/assets1/已发布数据集-已选_slices/icon_eye备份.png";
import iconDel from "@/assets1/已发布数据集-已选_slices/删除备份.png";
import { Message } from "element-ui";
import { SearchUser } from "@/api/user";
import { PostRequierments, PutRequierments,SearchRequiermentsSet } from "@/api/file";
import { FileUpLoad } from "@/server/UpLoadFile";
import store from "@/store";
export default {
  props: {
    data: Object,
  },
  data() {
    return {
      userList:[],
      tableData:[],
      radiolist: [
        {
          istrue: 0,
          icon: iconEye,
          type: "公开",
          content: "所有人都可以看见.",
        },
        {
          istrue: 1,
          icon: iconDel,
          type: "私密",
          content: "只有数据发布者可见,发布后可修改为公开..",
        },
      ],
      iconEye,
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        data: [],
        description: "",
        industry: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入符合规范的数据资源名称",
            trigger: "blur",
          },
          {
            min: 3,
            max: 40,
            message: "长度在 3 到 40 个字符",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message:
              "请输入具体描述您的数据资源需求,限3000字以内，如超出请传附件",
            trigger: "blur",
          },
          {
            min: 0,
            max: 3000,
            message: "长度在 0 到 3000 个字符",
            trigger: "blur",
          },
        ],
        data: [{ required: true }],
        industry: [
          {
            required: true,
          },
        ],
      },
      imageUrl: "",
      options: [
        {
          value: "工业制造",
          label: "工业制造",
        },
        {
          value: "交通运输",
          label: "交通运输",
        },
        {
          value: "金融服务",
          label: "金融服务",
        },
        {
          value: "科技创新",
          label: "科技创新",
        },
        {
          value: "绿色低碳",
          label: "绿色低碳",
        },
        {
          value: "气象服务",
          label: "气象服务",
        },
        {
          value: "商贸流通",
          label: "商贸流通",
        },
        {
          value: "文化旅游",
          label: "文化旅游",
        },
        {
          value: "现代农业",
          label: "现代农业",
        },
        {
          value: "医疗健康",
          label: "医疗健康",
        },
        {
          value: "应急管理",
          label: "应急管理",
        },
        {
          value: "城市治理",
          label: "城市治理",
        },
      ],
      options2: [
        {
          value: "文本",
          label: "文本",
        },
        {
          value: "图片",
          label: "图片",
        },
        {
          value: "视频",
          label: "视频",
        },
        {
          value: "音频",
          label: "音频",
        },
        {
          value: "点云",
          label: "点云",
        },
      ],
      value1: [],
      value2: [],
      list: [
        {
          contentList: [
            { title: "数据介绍", p: "数据介绍" },
            { title: "数据结构", p: "数据结构" },
            { title: "简介", p: "简介" },
          ],
        },
      ],
      ind: 0,
      radioind: 0,
    };
  },
  methods: {
    delOriginal(id){
      this.tableData=this.tableData.filter(item=>item.id!==id)
    },
  async  getUserList(page){
    const page_size=5
      const res=await SearchUser({
        page_no:page,
        page_size,
        
      })
      this.userList.push(...res.users)
      if(res.total>page*page_size){
        this.getUserList(page+1)
      }
      console.log(this.userList,'res')
    },
    getUserInfo(id){
      const res=this.userList.find(item=>item.id===id)
      return res.username

    },
    async getOriginal(){
      if(!this.formLabelAlign.original.trim()){
        return
      }
      const res = await SearchRequiermentsSet(Number(this.formLabelAlign.original.trim()))
      this.tableData.push(res)
      console.log(this.tableData,'111')
    },
    cancel() {
      this.$router.go(-1);
    },
    SplieName(val) {
      if (!val) return "";
      return val.slice(val.lastIndexOf("/") + 1);
    },
    DelFile() {
      this.formLabelAlign.data = [];
    },
    handleRemove(file) {
      console.log(file.name);
      const index = this.formLabelAlign.data.findIndex((path) =>
        path.includes(file.name)
      );

      if (index !== -1) {
        this.formLabelAlign.data.splice(index, 1); // 删除该元素
      }
      console.log(this.formLabelAlign.data);
    },
    draft() {
      let data=null
      if(this.tableData.length>0){
        data={
          title: this.formLabelAlign.name,
            tags: this.formLabelAlign.industry,
            attachment_bucket: "sxdatasets",
            attachment_object: this.formLabelAlign.data[0],
            description: this.formLabelAlign.description,
            is_draft: true,
            original_id:this.tableData[0].id
        }
      }
      else{
        data={
          title: this.formLabelAlign.name,
            tags: this.formLabelAlign.industry,
            attachment_bucket: "sxdatasets",
            attachment_object: this.formLabelAlign.data[0],
            description: this.formLabelAlign.description,
            is_draft: true,
        }
      }
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          console.log("submit");
          console.log(this.formLabelAlign);
          const res = await PostRequierments({
            ...data
          });
          console.log(res);

          this.$refs.formRef.resetFields();
          Message({
            message: "保持草稿成功",
            type: "success",
          });
        } else {
          console.log(this.formLabelAlign);
          console.log("error submit!!");
        }
      });
    },
    release() {
      let data=null
      if(this.tableData.length>0){
       data={
        title: this.formLabelAlign.name,
              tags: this.formLabelAlign.industry,
              attachment_bucket: "sxdatasets",
              attachment_object: this.formLabelAlign.data[0],
              description: this.formLabelAlign.description,
              is_draft: false,
              original_id:this.tableData[0].id
       }
      }
      else{
        data={
          title: this.formLabelAlign.name,
              tags: this.formLabelAlign.industry,
              attachment_bucket: "sxdatasets",
              attachment_object: this.formLabelAlign.data[0],
              description: this.formLabelAlign.description,
              is_draft: false,
        }
      }
      if (this.data) {
       
        console.log(this.formLabelAlign.industry);
        this.$refs.formRef.validate(async (valid) => {
          if (valid) {
            const res = await PutRequierments(
              {
                title: this.formLabelAlign.name,
                tags: this.formLabelAlign.industry,
                attachment_bucket: "sxdatasets",
                attachment_object: this.formLabelAlign.data[0],
                description: this.formLabelAlign.description,
                status: 2,

              },
              this.data.id
            );
            console.log(res);

            this.$router.push("Published");
            Message({
              message: "修改需求成功",
              type: "success",
            });
          } else {
            console.log(this.formLabelAlign);
            console.log("error submit!!");
          }
        });
      } 
      else {
        this.$refs.formRef.validate(async (valid) => {
          if (valid) {
            console.log("submit");
            console.log(this.formLabelAlign);
            const res = await PostRequierments({
             ...data
            });
            console.log(res);

            this.$refs.formRef.resetFields();
            Message({
              message: "发布需求成功",
              type: "success",
            });
          } else {
            console.log(this.formLabelAlign);
            console.log("error submit!!");
          }
        });
      }
    },
    async UploadFile(options) {
      try {
        const res2 = await FileUpLoad(options.file);
        console.log(res2, "res2");
        if (res2) {
          this.formLabelAlign.data.push(res2);
          console.log(res2);
        }
      } catch (error) {
        console.error("文件上传失败:", error);
        Message({
          message: "文件上传失败",
          type: "error",
        });
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleClick(i) {
      this.ind = i;
    },
    handleRadio(item) {
      this.radioind = item.istrue;
    },
  },
  mounted() {
    this.getUserList(1)
  },
  watch: {
    value1(newValue) {
      if (newValue.length !== 0) {
        document.querySelectorAll(".el-input--suffix input")[0].style.border =
          "none";
        document.querySelectorAll(
          ".el-input--suffix input"
        )[0].style.backgroundColor = "#F8F8F8";
        document.querySelectorAll(
          ".el-input--suffix input"
        )[0].style.boxShadow = "none";
      } else {
        document.querySelectorAll(".el-input--suffix input")[0].style.border =
          "1px solid #DCDFE6";
        document.querySelectorAll(
          ".el-input--suffix input"
        )[0].style.backgroundColor = "#fff";
        document.querySelectorAll(
          ".el-input--suffix input"
        )[0].style.boxShadow = "0px 0px 5px 1px #E0E0E0";
      }
    },
    value2(newValue) {
      if (newValue.length !== 0) {
        document.querySelectorAll(".el-input--suffix input")[1].style.border =
          "none";
        document.querySelectorAll(
          ".el-input--suffix input"
        )[1].style.backgroundColor = "#F8F8F8";
        document.querySelectorAll(
          ".el-input--suffix input"
        )[1].style.boxShadow = "none";
      } else {
        document.querySelectorAll(".el-input--suffix input")[1].style.border =
          "1px solid #DCDFE6";
        document.querySelectorAll(
          ".el-input--suffix input"
        )[1].style.backgroundColor = "#fff";
        document.querySelectorAll(
          ".el-input--suffix input"
        )[1].style.boxShadow = "0px 0px 5px 1px #E0E0E0";
      }
    },
  },
  created() {
    console.log(this.data);

    console.log();
    if (this.data) {
      const url = this.data.attachment_url + "";
      this.formLabelAlign.name = this.data.title;
      this.formLabelAlign.industry = [...this.data.tags];
      this.formLabelAlign.data.push(url.slice(url.lastIndexOf("//") + 2));
      this.formLabelAlign.description = this.data.description;
    }
    console.log(this.formLabelAlign, "test");
  },
};
</script>

<style scoped>
.originalBox-select {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  
}
::v-deep .originalBox-select .el-input{
  width: 50%;
  margin-right: 20px;
}
.OneTitle {
  width: 100%;
  padding: 16px;
  background-color: #f7f8fc;
  border-radius: 4px;
  margin-bottom: 20px;
  box-sizing: border-box;
  font-family: Medium;
  font-size: 16px;
}
.Datasets1 {
  width: 100%;
  box-sizing: border-box;
}

.Datasets1 .el-table__header-wrapper {
  margin-bottom: 10px !important;
}
.btnlist button {
  cursor: pointer;
}
.attachment-box {
  margin-top: 10px;
  display: flex;
  align-items: center;
  background: #f7f7f7;
  border-radius: 4px;
  border-radius: 6px;
  padding: 10px 20px;
  width: 320px;
}
.file-icon {
  width: 38px;
  height: 38px;
  margin-right: 12px;
}
.file-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.file-name {
  width: 120px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-family: Regular;
  color: #222;
}
.file-size {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  font-family: Regular;
  color: #999;
}
.download-link {
  color: red;
  font-size: 14px;

  text-decoration: none;
  margin-left: 12px;
}
.sucess {
  color: white;
  background-color: #0d53ff;
}
.save {
  color: #666;
  background-color: #f7f7f7;
}
.del {
  color: #666;
  background-color: #fff;
}
.btnlist {
  margin-top: 10px;
  display: flex;
}
.btnlist button {
  width: 80px;
  height: 32px;
  margin-right: 20px;

  font-size: 14px;
  font-family: Regular;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}
.radio.radio-active::before {
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  background-color: #0d53ff;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.radio.radio-active {
  border: 1px solid #0d53ff;
}
.radio {
  position: relative;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #000;
  margin-right: 20px;
  cursor: pointer;
}
.radio-box {
  display: flex;
  align-items: center;
}
.radio-box .type {
  font-size: 14px;
  line-height: 20px;
  font-family: Regular;
  color: #000;
  margin: 0 8px;
}
.radio-box p {
  font-size: 12px;
  line-height: 20px;
  font-family: Regular;
  color: #999999;
}
.radio-box img {
  width: 20px;
  height: 20px;
  object-fit: cover;
}
.select-box-content textarea {
  padding: 10px 20px;
  border: none;
  outline: none;
  font-family: Regular;
  width: 100%;
  height: 100%;
  resize: none;
}
.select-box-acitve.Active-box-head {
  z-index: 1;
  height: 31px;
}
.select-box-content {
  position: absolute;
  top: 30px;
  width: 100%;
  height: 100px;
  border: 1px solid rgba(153, 153, 153, 0.3);
}
.select-box-head {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  background-color: #fff;
}
.select-box-head p {
  width: 90px;
  height: 30px;
  line-height: 30px;
  background-color: #eee;
  border-radius: 4px 4px 0 0;
  text-align: center;
  color: #999;
  margin-right: 2px;
  border: 1px solid rgba(153, 153, 153, 0.3);
  border-bottom: none;
  cursor: pointer;
}
.select-box-head .select-box-acitve {
  background-color: #fff;
  color: #0d53ff;
  font-size: 14px;
}
.select-box {
  position: relative;
  width: 570px;
  height: 135px;
  font-family: Regular;
}
.el-upload__tip {
  line-height: 30px;
  font-size: 12px;
  font-family: Regular;
  color: #999999;
  margin-left: 11px;
}
.uploadbtn {
  height: 36px;

  border: 1px solid rgba(13, 83, 255, 0.6);
  border-radius: 4px;
  background-color: rgba(13, 83, 255, 0.1);
  font-size: 14px;
  color: #0d53ff;
}
.upload-demo {
  display: flex;
}
/* .active{
  border: none;
  box-shadow: none;
  background-color: #F8F8F8;
} */
::v-deep .el-input--suffix input {
}
::v-deep .el-select {
  width: 576px;
}

::v-deep .el-select__tags-text {
  line-height: 17px;
}
::v-deep .el-tag {
  padding: 8px;
  color: black;
  font-family: Regular;
  height: auto;
  border: 1px solid #0d53ff;
  background-color: #fff;
  font-size: 14px;
}
/* .select{
 background-color: #F8F8F8;
  border: none;
} */
.P-message {
  font-size: 12px;
  font-family: Regular;
  color: #999999;
  height: 17px;
  line-height: 17px;
}

/* .el-form-item {
  display: flex;
  align-items: center;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 10px;
} */
/* ::v-deep  .el-form-item__error{
left:calc();
top: 0;
 } */
::v-deep .avatar-uploader .el-upload {
  /* border: 1px solid #E0E0E0; */
  box-shadow: 0px 0px 5px 2px #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  height: 60px;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
.eleInput {
  width: 570px;
  height: 36px;
}
::v-deep .el-input__inner {
  box-shadow: 0px 0px 5px 1px #e0e0e0;
}
.form-group {
  display: flex;
  justify-content: flex-end;
}
.head-title {
  font-family: Medium;
  font-size: 24px;
  margin-bottom: 26px;
}
.release-container {
  padding-left: 24px;
  padding-top: 24px;
}
</style>
<style>
.Text .el-textarea__inner {
  height: 120px;
  box-shadow: 0px 0px 5px 1px #e0e0e0;
}
.Text .el-textarea__inner::placeholder {
  font-family: Regular;
  font-size: 14px;
  color: #c1c1c1;
}
</style>
